module.exports = __webpack_public_path__ + "img/line.360e38ae.png";